import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"

import RegulaminFilePromo1 from "../../static/Regulamin-promocja-ORLENCharge-3-cykl-pl.pdf"

import RegulaminFile from "../../static/ORLEN_REGULAMIN_SWIADCZENIA_USLUG_LADOWANIA_KLIENT_INDYWIDUALNY_WAZNY_OD_12092024.pdf"
import RegulaminFileFlota from "../../static/ORLEN_REGULAMIN_SWIADCZENIA_USLUG_LADOWANIA_KLIENT_FLOTOWY_WAZNY_OD_12092024.pdf"

import RegulaminFileOld from "../../static/regulamin-swiadczenia-uslug-ladowania-PKN-ORLEN-2024.pdf"
import RegulaminFileFlotaOld from "../../static/regulamin-swiadczenia-uslug-ladowania-PKN-ORLEN-flota-2024.pdf"

import '../sass/main.scss'

const query = graphql`
  {
    fotka: file(relativePath: { eq: "regulamin-bg.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Regulamin = () => {
  const data = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="ORLEN | Regulamin" />
      <Sublinks />
      <BackgroundImage
        Tag="section"
        className={`sub-visual sub-visual-regulamin`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <Infolinia customStyle="d-none d-md-flex js-infolinia" />
        <div className="bg-overlay"></div>
        <div
          className="visual-content col-md-8 ie11animfix"
          data-sal="slide-up"
          data-sal-delay="500"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          <h1 className="font-xxl text-center font-bold">
            REGULAMIN PROMOCJI „ŁADUJ AUTO TANIEJ Z ORLEN CHARGE”
          </h1>
          <p className="font-md font-light">Kliknij i pobierz regulamin promocji w formacie pdf:</p>
          <div className="text-center">
            <a
              href={RegulaminFilePromo1}
              target="_blank" rel="noreferrer"
              className="d-inline-flex flex-column mx-2 mx-xl-4 align-items-center"
            >
            <div className="btn-download-sm">
              <span className="icon-pdf"></span>
            </div>
            <span className="btn-desc">Klient indywidualny / Klient flotowy</span>
            </a>

          </div>
          <p className="text-center font-xs font-light mt-2 mb-4">Regulamin promocji obowiązuje w czasie trwania promocji tj. od 9 do 22 grudnia 2024 roku.</p>
          <hr className="hr-decor"/>
          <h1 className="font-xxl font-bold text-center">
            REGULAMIN ŚWIADCZENIA USŁUG ŁADOWANIA
          </h1>
          <p className="font-md font-light text-center">
            Zanim skorzystasz ze stacji ładowania ORLEN Charge - zapoznaj się z Regulaminem świadczenia usług ładowania
          </p>
          <p className="text-center font-xs font-light mt-4">
            Kliknij i pobierz aktualny regulamin w formacie pdf: <a href={RegulaminFile} target="_blank" rel="noreferrer" className="text-white text-underline font-bold">klient indywidualny</a>  / <a href={RegulaminFileFlota} target="_blank" rel="noreferrer" className="text-white text-underline font-bold">klient flotowy</a>.
          </p>
          <p className="text-center font-xs font-light mb-4">Regulamin obowiązuje od 12 września 2024 roku.</p>
          <hr className="hr-decor"/>
          <p className="text-center font-xs font-light mt-4">Regulamin archiwalny ( <a href={RegulaminFileOld} target="_blank" rel="noreferrer" className="text-white text-underline">indywidualny</a> | <a href={RegulaminFileFlotaOld} target="_blank" rel="noreferrer" className="text-white text-underline">flotowy</a> ) obowiązujący do 11 września 2024 roku.</p>

        </div>
      </BackgroundImage>
    </Layout>
  )
}
export default Regulamin



